import "core-js/stable";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import store from "./redux/store";
import { Provider } from "react-redux";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

const container = document.getElementById("root");
const root = createRoot(container!);

const router = createBrowserRouter(
    [
        {
            path: "/*",
            element: <App />,
        },
    ],
    { basename: process.env.PUBLIC_URL },
);

root.render(
    <Provider store={store}>
        <RouterProvider router={router} />
    </Provider>,
);
